
import { GoogleGenAI } from "@google/genai";

// SAFEGUARD: Check if 'process' exists before accessing it to prevent browser crashes
const API_KEY = (typeof process !== 'undefined' && process.env && process.env.API_KEY) ? process.env.API_KEY : '';

// Fallback response if no key is provided
const MOCK_RESPONSE = "I apologize, but I am currently running in demo mode without an active AI connection. In the live version, I would explain the specific metallurgy of our SAE 1075 steel or guide you through the safety protocols.";

export const getChatResponse = async (
  message: string, 
  history: {role: 'user' | 'model', text: string}[]
): Promise<string> => {
  if (!API_KEY) {
    console.warn("API_KEY not found. Using mock response.");
    return new Promise(resolve => setTimeout(() => resolve(MOCK_RESPONSE), 1000));
  }

  try {
    const ai = new GoogleGenAI({ apiKey: API_KEY });
    const chat = ai.chats.create({
      model: 'gemini-3-flash-preview',
      config: {
        systemInstruction: `You are the specialized AI Support Agent for "The Machete Man", a B2B wholesale platform for premium Colombian machetes.
        
        Your Core Knowledge:
        1. **Metallurgy**: We use German/English engineered SAE 1075 & 1095 High Carbon Steel. It holds an edge better than stainless but requires care (oiling) to prevent rust.
        2. **Safety**: Explain the difference between a Machete (Velocity tool for green vegetation) vs. a Hatchet (Mass tool for dead wood). Never use a machete on hard wood or knots; it will damage the blade. This is not a warranty defect.
        3. **Compliance**: We adhere to Canadian Law (Manitoba Bill 39). Buyers must be 18+ and verified businesses. Shipping requires Adult Signature (19+).
        4. **Ordering**: We sell in mixed cases of 12. Retailers can mix and match styles.

        Tone: Professional, knowledgeable, safety-conscious, but friendly to retail business owners.
        `,
      },
      history: history.map(h => ({
        role: h.role,
        parts: [{ text: h.text }]
      }))
    });

    const result = await chat.sendMessage({ message });
    return result.text || "I didn't catch that. Could you please rephrase?";
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "I am experiencing a temporary connection issue. Please try again later or contact human support.";
  }
};
